import { ActivityBuilderRow } from './activity-builder-slide.style';
import { ActivityBuilderContainerSlide } from './activity-builder.style';
import * as Styled from './activity-builder-skeleton.style';

const ActivityBuilderNavSkeleton = () => (
  <Styled.ActivityBuilderSkeletonSlidesNav>
    <Styled.ActivityBuilderSkeletonSlideItems>
      <Styled.ActivityBuilderSkeletonSlideItem />
      <Styled.ActivityBuilderSkeletonSlideItem />
      <Styled.ActivityBuilderSkeletonSlideItem />
    </Styled.ActivityBuilderSkeletonSlideItems>
  </Styled.ActivityBuilderSkeletonSlidesNav>
);

const ActivityBuilderSkeleton = () => (
  <Styled.ActivityBuilderSkeleton>
    <ActivityBuilderNavSkeleton />
    <Styled.ActivityBuilderSkeletonCanvas $isActive={false}>
      <ActivityBuilderContainerSlide>
        <ActivityBuilderRow>
          <Styled.ActivityBuilderSkeletonActivityControlRow>
            <Styled.ActivityBuilderSkeletonActivityControl />
          </Styled.ActivityBuilderSkeletonActivityControlRow>
        </ActivityBuilderRow>
        <Styled.ActivityBuilderSkeletonRow>
          <Styled.ActivityBuilderSkeletonSlideRow>
            <Styled.ActivityBuilderSkeletonSlide />
          </Styled.ActivityBuilderSkeletonSlideRow>
        </Styled.ActivityBuilderSkeletonRow>
      </ActivityBuilderContainerSlide>
    </Styled.ActivityBuilderSkeletonCanvas>
  </Styled.ActivityBuilderSkeleton>
);

export default ActivityBuilderSkeleton;

export const ActivityBuilderSkeletonSlide = () => (
  <Styled.ActivityBuilderSkeleton>
    <ActivityBuilderRow>
      <Styled.ActivityBuilderSkeletonActivityControlRow>
        <Styled.ActivityBuilderSkeletonActivityControl />
      </Styled.ActivityBuilderSkeletonActivityControlRow>
    </ActivityBuilderRow>
    <Styled.ActivityBuilderSkeletonRow>
      <Styled.ActivityBuilderSkeletonSlideRow>
        <Styled.ActivityBuilderSkeletonSlide />
      </Styled.ActivityBuilderSkeletonSlideRow>
    </Styled.ActivityBuilderSkeletonRow>
  </Styled.ActivityBuilderSkeleton>
);
